import api from '@/api/api'

export default {
    index() {
        return api.get('main/notification-settings')
    },
    update(id, payload) {
        return api.put(`main/notification-settings/${id}`, payload)
    },
    postAnnouncement(payload) {
        return api.post('main/announcements', payload)
    },
}
